import { render, staticRenderFns } from "./EditTransferDialog.vue?vue&type=template&id=3a05d587&scoped=true"
import script from "./EditTransferDialog.vue?vue&type=script&lang=js"
export * from "./EditTransferDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a05d587",
  null
  
)

export default component.exports